// Paginación: schema reutilizable para queries y helper genérico
// para construir schemas de respuesta paginada por entidad.
import { z } from 'zod';

export const PaginationSchema = z.object({
  page: z.coerce.number().int().positive().max(10_000).default(1),
  pageSize: z.coerce.number().int().positive().max(100).default(20),
});

export type Pagination = z.infer<typeof PaginationSchema>;

// Helper genérico — uso típico: `PaginatedResponseSchema(EventSchema)`.
export const PaginatedResponseSchema = <T extends z.ZodTypeAny>(item: T) =>
  z.object({
    items: z.array(item),
    page: z.number().int().positive(),
    pageSize: z.number().int().positive(),
    total: z.number().int().nonnegative(),
    hasNextPage: z.boolean(),
  });

// Interfaz pública por si el caller necesita declarar el tipo sin
// pasar por el schema (p. ej. mocks o servicios HTTP).
export interface PaginatedResponse<T> {
  items: T[];
  page: number;
  pageSize: number;
  total: number;
  hasNextPage: boolean;
}

// Fuente de verdad del cálculo de `hasNextPage`: lo comparten el
// servicio (al construir la respuesta) y el cliente (al recomputar
// tras un borrado optimista), para que no diverjan.
export function hasNextPage(
  page: number,
  pageSize: number,
  total: number,
): boolean {
  return page * pageSize < total;
}
